import { ConfirmationContextProvider } from 'lib/components/useConfirm/ConfirmationContextProvider';
import AdminPanel from 'modules/admin/components/admin-panel/AdminPanel';
import AuthPanel from 'modules/auth/components/auth-panel/AuthPanel';
import UnsubscribeRoutes from 'modules/unsubscribe/routes';
import React from 'react';
import { useHistory } from 'react-router-dom';
import useDebugViews from 'useDebugViews';
import './App.scss';
import { INITIAL_APP_STATE } from './appReducer';
import './index.scss';
import useApp from './useApp';

export const AppContext = React.createContext({
  appState: INITIAL_APP_STATE,
});

AppContext.displayName = 'AppContext';

function App() {
  const { appState, isLoggedIn, isUnsubscribeLink, logout, doUserLogout } =
    useApp();
  const { debugViewsList } = useDebugViews();
  const history = useHistory();

  const getAppMainComponent = () => {
    if (history?.location?.pathname === '/login/cookie') return <AuthPanel />;
    if (isLoggedIn()) return <AdminPanel />;
    if (isUnsubscribeLink) return <UnsubscribeRoutes />;
    return <AuthPanel />;
  };

  return (
    <AppContext.Provider value={{ appState, isLoggedIn, logout, doUserLogout }}>
      <ConfirmationContextProvider>
        <div className='App'>
          {getAppMainComponent()}
          {!!debugViewsList?.length && (
            <div className='debug-views-notice'>
              Debug views ON:{' '}
              {debugViewsList.map((v, idx) => `${idx !== 0 ? ', ' : ''}${v}`)}
            </div>
          )}
        </div>
      </ConfirmationContextProvider>
    </AppContext.Provider>
  );
}

export default App;
